import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import ActivityLogCards from '@app/components/apps/ActivityLog/ActivityLogCards';
import ActivityLogTable from '@app/components/apps/ActivityLog/ActivityLogTable';
import ActivityLogTimeline from '@app/components/apps/ActivityLog/ActivityLogTimeline';
import ActivityLogPage from '@app/components/apps/ActivityLog/ActivityLogPage';

const ViewLogs: React.FC = () => {
  const { setBreadcrumb } = useHeader();
  const navigate = useNavigate();

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[{ path: '/activity_log', breadcrumbName: 'Activity Log' }]}
        style={{ marginBottom: '15px' }}
      />,
    );

    return () => {
      setBreadcrumb(undefined);
    };
  }, [setBreadcrumb, navigate]);

  return (
    <>
      <PageTitle>Activity Log</PageTitle>
      <Row gutter={[16, 16]} style={{ width: '100%' }}>
        <Col span={24}>
          <ActivityLogPage />
        </Col>
      </Row>
    </>
  );
};

export default ViewLogs;
